module.exports = __webpack_public_path__ + "static/media/minimize.55fbba23.svg";